import React from 'react';
import { Typography } from 'views/components/atoms/Typography';
import {
  FormattedDate,
  FormattedMessage,
  FormattedNumber,
  FormattedTime,
} from 'react-intl';
import { Color, FontSize, MAX_WIDTH } from 'views/constants';
import styled from '@emotion/styled';
import { Spacer } from 'views/components/atoms/Spacer';
import { localeIds } from 'locals';
import { DeviceFamilyType } from 'models/Device/enum';

const Wrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
`;

const DescriptionWrapper = styled.div`
  display: flex;
`;

const StyledDefinitionTeam = styled.dt`
  width: 142px;
`;

const StyledDefinitionDescription = styled.dd`
  margin-left: 20px;
`;

interface File {
  name: string;
  size: number;
}

interface AppFileInfoProps {
  file: File;
  releaseDate: Date;
  ttl: Date;
  minimumOsVersion: string;
  targetOsVersion: string;
  targetedDeviceFamily: DeviceFamilyType;
}

const fontSize = FontSize.XS;
const fontColor = Color.C2;
export const AppFileInfo: React.FC<AppFileInfoProps> = ({
  file,
  releaseDate,
  ttl,
  minimumOsVersion,
  targetOsVersion,
  targetedDeviceFamily,
}) => (
  <Wrapper>
    <Typography size={fontSize} color={fontColor}>
      {file.name}
    </Typography>

    <Spacer />

    <dl>
      <DescriptionWrapper>
        <StyledDefinitionTeam>
          <Typography size={fontSize} color={fontColor}>
            <FormattedMessage id={localeIds.appFileInfo.releaseDate} />:
          </Typography>
        </StyledDefinitionTeam>
        <StyledDefinitionDescription>
          <Typography size={fontSize} color={fontColor}>
            <FormattedDate value={releaseDate} format="default" />{' '}
            <FormattedTime value={releaseDate} format="default" />
          </Typography>
        </StyledDefinitionDescription>
      </DescriptionWrapper>

      <DescriptionWrapper>
        <StyledDefinitionTeam>
          <Typography size={fontSize} color={fontColor}>
            <FormattedMessage id={localeIds.appFileInfo.TTL} />:
          </Typography>
        </StyledDefinitionTeam>
        <StyledDefinitionDescription>
          <Typography size={fontSize} color={fontColor}>
            <FormattedDate value={ttl} format="default" />{' '}
            <FormattedTime value={ttl} format="default" />
          </Typography>
        </StyledDefinitionDescription>
      </DescriptionWrapper>

      <DescriptionWrapper>
        <StyledDefinitionTeam>
          <Typography size={fontSize} color={fontColor}>
            <FormattedMessage id={localeIds.appFileInfo.size} />:
          </Typography>
        </StyledDefinitionTeam>
        <StyledDefinitionDescription>
          <Typography size={fontSize} color={fontColor}>
            <FormattedNumber value={file.size / 1024.0} style="decimal" /> KB
          </Typography>
        </StyledDefinitionDescription>
      </DescriptionWrapper>

      <DescriptionWrapper>
        <StyledDefinitionTeam>
          <Typography size={fontSize} color={fontColor}>
            <FormattedMessage id={localeIds.appFileInfo.compatibility} />:
          </Typography>
        </StyledDefinitionTeam>
        <StyledDefinitionDescription>
          <Typography size={fontSize} color={fontColor}>
            iOS {minimumOsVersion} - {targetOsVersion}
          </Typography>
        </StyledDefinitionDescription>
      </DescriptionWrapper>

      <DescriptionWrapper>
        <StyledDefinitionTeam>
          <Typography size={fontSize} color={fontColor}>
            <FormattedMessage id={localeIds.appFileInfo.targetDeviceFamily} />:
          </Typography>
        </StyledDefinitionTeam>
        <StyledDefinitionDescription>
          <Typography size={fontSize} color={fontColor}>
            <FormattedMessage
              id={'deviceFamilyNames.' + targetedDeviceFamily}
            />
          </Typography>
        </StyledDefinitionDescription>
      </DescriptionWrapper>
    </dl>
  </Wrapper>
);
